export enum PaymentProvider {
  PAGOUNO = 'PAGOUNO',
  MOBBEX = 'MOBBEX',
  MERCADOPAGO = 'MERCADOPAGO',
  STRIPE = 'STRIPE'
}
